import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { handleLogin, isAuthenticated } from '../../utils/auth';
import './styling/Login.css';
import Header from '../Header';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard if already authenticated
    if (isAuthenticated()) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const success = await handleLogin(credentials.username, credentials.password);
      if (success) {
        navigate('/admin/dashboard');
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      setError('An error occurred during login');
    }
  };

  return (
    <div>
        <Header />
        
        <Box className="admin-login-container">
        <Paper elevation={3} className="admin-login-paper">
            <Typography variant="h5" component="h1" gutterBottom>
            Admin Login
            </Typography>
            
            {error && (
            <Typography color="error" variant="body2" className="error-message">
                {error}
            </Typography>
            )}

            <form onSubmit={handleLoginSubmit} className="admin-login-form">
            <TextField
                label="Username"
                variant="outlined"
                fullWidth
                margin="normal"
                value={credentials.username}
                onChange={(e) => setCredentials({...credentials, username: e.target.value})}
                required
            />
            <TextField
                type="password"
                label="Password"
                variant="outlined"
                fullWidth
                margin="normal"
                value={credentials.password}
                onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                required
            />
            <Button 
                type="submit" 
                variant="contained" 
                color="primary" 
                fullWidth 
                className="login-button"
            >
                Login
            </Button>
            <Button 
                variant="text" 
                color="primary" 
                fullWidth 
                onClick={() => navigate('/')}
                className="back-button"
            >
                Back to Home
            </Button>
            </form>
        </Paper>
        </Box>
    </div>
  );
};

export default AdminLogin;